"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseInvitationMailJob = void 0;
const paths_1 = require("./paths");
const parseInvitationMailJob = (value) => {
    if (!value || typeof value !== 'object')
        throw new Error('Invalid invitation mail job.');
    const job = value;
    (0, paths_1.requireOperationId)(job.operationId);
    paths_1.firestorePaths.invitation(job.collectionId, job.invitationId);
    if (job.schemaVersion !== 1 ||
        !/^[a-f0-9]{64}$/.test(job.tokenHash) ||
        !['invitation', 'reminder'].includes(job.kind) ||
        !Number.isSafeInteger(job.attempts) ||
        job.attempts < 0 ||
        job.attempts > 5 ||
        (job.nextAttemptSeconds !== null &&
            (!Number.isSafeInteger(job.nextAttemptSeconds) ||
                job.nextAttemptSeconds < 0)) ||
        (job.leaseId !== null && (0, paths_1.requireOperationId)(job.leaseId) !== job.leaseId)) {
        throw new Error('Invalid invitation mail job.');
    }
    return job;
};
exports.parseInvitationMailJob = parseInvitationMailJob;
